export const enCompanyDataPageTranslation = {
  company_data: {
    header: {
      title: 'Company Data',
      description:
        'Enter your company data to get a consolidated view of your key financial and operational metrics.',
    },
    table: {
      columns: {
        annual_data: 'Annual Data',
      },
    },
    modal_info: {
      text: 'The financial information for {id} needs to be updated!',
    },
    placeholders: {
      select_month: 'Select a month...',
      input_data: 'Enter data',
    },
    save: 'Save',
    sectors: {
      title: 'Enter the main business sectors',
      description:
        'Enter up to {{max}} main business sectors and their respective percentages. If you don’t have the data, leave the fields blank.',
      columns: {
        sector: 'Industry',
        percentage: 'Percentage',
        clear: 'Clear',
      },
      placeholders: {
        select_sector: 'Select a sector',
        percentage: '0',
      },
    },
    toast: {
      save_success: 'Data saved successfully!',
      save_error: 'Error saving data, please try again!',
      grade_change_validation_error:
        'It was not possible to validate the change in grade structure!',

      sectors_select_before_percentage:
        'You must select a sector before saving the percentage.',
      sectors_invalid_percentages:
        'Invalid percentages. Please check the fields.',
      sectors_sum_exceeds: 'The sum of the percentages cannot exceed 100%.',
      sectors_sum_exceeds_after_clear:
        'The sum of the percentages exceeds 100%.',
      sectors_save_success: 'Sectors saved successfully',
      sectors_save_error: 'Failed to save sectors. Please try again.',
      sectors_load_error: 'Unable to load sectors.',
    },
  },
};
